import { render, staticRenderFns } from "./ResourcesSingle.vue?vue&type=template&id=2d033a90&scoped=true"
import script from "./ResourcesSingle.vue?vue&type=script&lang=js"
export * from "./ResourcesSingle.vue?vue&type=script&lang=js"
import style0 from "./ResourcesSingle.vue?vue&type=style&index=0&id=2d033a90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d033a90",
  null
  
)

export default component.exports